const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1'])

function normalizeBaseUrl(url: string): string {
  return url.replace(/\/+$/, '')
}

function isLocalHost(hostname: string): boolean {
  return LOCAL_HOSTS.has(hostname.replace(/^\[|\]$/g, ''))
}

function buildUrlWithHost(url: URL, hostname: string): string {
  const host = hostname.includes(':') ? `[${hostname.replace(/^\[|\]$/g, '')}]` : hostname
  const port = url.port ? `:${url.port}` : ''
  return normalizeBaseUrl(`${url.protocol}//${host}${port}${url.pathname}${url.search}${url.hash}`)
}

export function getApiBaseUrl(): string {
  const envUrl = import.meta.env['VITE_API_URL'] as string | undefined

  if (typeof window === 'undefined') {
    return envUrl ? normalizeBaseUrl(envUrl) : ''
  }

  const currentOrigin = normalizeBaseUrl(window.location.origin)

  if (!envUrl) {
    return currentOrigin
  }

  try {
    const parsedEnvUrl = new URL(envUrl, currentOrigin)
    const normalizedEnvUrl = normalizeBaseUrl(parsedEnvUrl.toString())
    const currentHost = window.location.hostname

    if (parsedEnvUrl.origin === currentOrigin) {
      return currentOrigin
    }

    if (isLocalHost(parsedEnvUrl.hostname) && !isLocalHost(currentHost)) {
      return currentOrigin
    }

    if (isLocalHost(parsedEnvUrl.hostname) && isLocalHost(currentHost)) {
      return buildUrlWithHost(parsedEnvUrl, currentHost)
    }

    return normalizedEnvUrl
  } catch {
    return currentOrigin
  }
}
